import { useKeyDown } from './useKeyDown';

export const useEscape = (callback: () => void, isEnabled = true) => {
  useKeyDown('Escape', callback, isEnabled);
};
